
export namespace DaysAvailableNamespace{
  export interface ModalI{
      onClose: () => void
  }

  export interface AllowanceModalProps{
    allowance: number,
    userId: number
  }

  export interface TransferredModalProps{
    transferredDays: number,
    userId: number
  }

  export interface HistoryModalProps{
    userId: number
  }

  export interface CompensatoryOffModalProps{
    userId: number
  }

  export type TransferredModalCallProps = ModalI & TransferredModalProps;
  export type AllowanceModalCallProps = ModalI & AllowanceModalProps;
  export type HistoryModalCallProps = ModalI & HistoryModalProps;
  export type CompensatoryOffCallModalProps = ModalI & CompensatoryOffModalProps;
  export enum BalanceType {
    ALLOWANCE = 'ALLOWANCE',
    TRANSFER_DAYS = 'TRANSFER_DAYS'
  }
  export interface UpdateBalanceDto{
    employeeId: number
    newValue: number
    comment: string,
    isAllowancePermanent: boolean,
    valueType: BalanceType,
    oldValue: number
  }

  export type UpdateAllowanceBaseFields = Omit<UpdateBalanceDto, 'employeeId' | 'valueType' | 'oldValue'>
  export type UpdateTransferredDaysBaseFields = Pick<UpdateBalanceDto, 'newValue' | 'comment'>

  export type BalanceHistoryMessage = {
    balanceChangeMessage: string,
    balanceChangeTime: string,
    valueType: BalanceType
  }

  export type BalanceHistoryCollection = {
    changesHistory: BalanceHistoryMessage[],
    date: string
  }[]
}